import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import ProductCard from '../components/ProductCard';
import { Button } from '../components/ui/button';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Catalog = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const selectedCategory = searchParams.get('category');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [productsRes, categoriesRes] = await Promise.all([
          axios.get(`${API}/products${selectedCategory ? `?category=${selectedCategory}` : ''}`),
          axios.get(`${API}/categories`)
        ]);
        setProducts(productsRes.data);
        setCategories(categoriesRes.data);
      } catch (error) {
        console.error('Error carregant dades:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedCategory]);

  const handleCategoryChange = (categoryId) => {
    if (categoryId) {
      setSearchParams({ category: categoryId });
    } else {
      setSearchParams({});
    }
  };

  return (
    <div data-testid="catalog-page" className="min-h-screen pt-32 pb-24 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="mb-12"
        >
          <h1 className="font-heading text-4xl md:text-6xl font-medium tracking-tight leading-tight text-foreground mb-6">
            El Nostre Catàleg
          </h1>
          <p className="text-lg leading-relaxed text-muted-foreground max-w-2xl">
            Descobreix la nostra col·lecció completa de productes seleccionats amb cura.
          </p>
        </motion.div>

        {/* Category Filter */}
        <div data-testid="category-filter" className="flex flex-wrap gap-3 mb-12">
          <Button
            onClick={() => handleCategoryChange(null)}
            variant={!selectedCategory ? "default" : "outline"}
            className="rounded-full"
            data-testid="category-all"
          >
            Tots
          </Button>
          {categories.map((category) => (
            <Button
              key={category.id}
              onClick={() => handleCategoryChange(category.id)}
              variant={selectedCategory === category.id ? "default" : "outline"}
              className="rounded-full"
              data-testid={`category-filter-${category.id}`}
            >
              {category.name}
            </Button>
          ))}
        </div>

        {/* Products Grid */}
        {loading ? (
          <div className="text-center py-12">
            <p className="text-muted-foreground">Carregant productes...</p>
          </div>
        ) : products.length === 0 ? (
          <div data-testid="no-products" className="text-center py-12">
            <p className="text-muted-foreground">No s'han trobat productes en aquesta categoria.</p>
          </div>
        ) : (
          <div data-testid="products-grid" className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {products.map((product) => (
              <ProductCard key={product.id} product={product} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Catalog;